// @ts-strict-ignore
import React from 'react'

const ErrorMessage = ({ error }) => {
  return (
    <div className='TravelMoneyError'>
      <div className='TravelMoneyError__title'>{error.title}</div>
      <div className='TravelMoneyError__subtitle'>{error.subtitle}</div>
    </div>
  )
}

export default ErrorMessage
